export default __webpack_public_path__ + "static/CookiePolicy-6f7c6bdc34ef7b66934a318d5baf8643.pdf";